import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const TextHighlightIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 16" sx={{ width: props.width || '16px', height: props.height || '16px' }}>
      <path id="Rectangle 2411" d="M0 1C0 0.447715 0.447715 0 1 0H8V8H0V1Z" fill="#EA3632" />
      <path
        id="Rectangle 2413"
        d="M0 8H8V15C8 15.5523 7.55228 16 7 16H1C0.447715 16 0 15.5523 0 15V8Z"
        fill="#0D96FF"
        fillOpacity="0.5"
      />
      <path id="Rectangle 2412" d="M8 0H15C15.5523 0 16 0.447715 16 1V8H8V0Z" fill="#EA3632" fillOpacity="0.5" />
      <path id="Rectangle 2414" d="M8 8H16V15C16 15.5523 15.5523 16 15 16H8V8Z" fill="#0D96FF" />
    </SvgIcon>
  );
};

export default TextHighlightIcon;
